import { parseRawJson } from "../util";
export var getSeatMap = function () {
    var _a, _b;
    var dataString = (_b = (_a = document.getElementById('performance-prices-seatmap')) === null || _a === void 0 ? void 0 : _a.getAttribute('data-performance-prices')) !== null && _b !== void 0 ? _b : null;
    return dataString ? parseRawJson(JSON.parse(dataString)) : null;
};
export var getPerformanceId = function () {
    var _a, _b, _c;
    var perfTimeActive = (_a = document.querySelector('.performance-time.active')) === null || _a === void 0 ? void 0 : _a.getAttribute('data-id');
    if (perfTimeActive) {
        return perfTimeActive;
    }
    else {
        return (_c = (_b = document.getElementById('performance-prices-seatmap')) === null || _b === void 0 ? void 0 : _b.getAttribute('data-id')) !== null && _c !== void 0 ? _c : null;
    }
};
export var isPerformanceReserved = function () {
    var _a, _b, _c, _d;
    return ((_b = ((_a = document.querySelector('.performance-time.active')) === null || _a === void 0 ? void 0 : _a.getAttribute('data-reserved')) === 'true') !== null && _b !== void 0 ? _b : false)
        || Boolean((_d = ((_c = document.getElementById('performance-prices-seatmap')) === null || _c === void 0 ? void 0 : _c.getAttribute('data-reserved')) === 'true') !== null && _d !== void 0 ? _d : false);
};
export var updateBasketPrice = function (price) {
    var priceSpan = document.querySelectorAll('span.price');
    if (priceSpan) {
        priceSpan.forEach(function (element) { element.textContent = price; });
    }
};
export var getRed61Config = function () {
    return window['red61'];
};
